/**
 * Cover-storageId → knowledge_id — Auflösung für die Standalone-Detailseite.
 *
 * GENERIERT von scripts/gen-knowledge-ids.mjs (katalog-getrieben, binom-Match
 * gegen /knowledge/species). NICHT von Hand editieren — bei neuen Arten/Records
 * `node scripts/gen-knowledge-ids.mjs` laufen lassen. Hand-Sonderfälle: OVERLAY
 * im Generator.
 *
 * Warum die Map existiert: Der Standalone-Detail öffnet über knowledge_id (nicht
 * storageId), weil der Dual-Store pro Art unterschiedlich herum liegt und nur die
 * knowledge_id stabil ist (Issue #442/#459). Arten ohne Record fehlen bewusst und
 * fallen in App.tsx auf den storageId-Pfad zurück.
 */
export const COVER_TO_KNOWLEDGE_ID: Record<number, number> = {
  101570: 244, // Aga-Kröte
  101571: 245, // Amerikanischer Ochsenfrosch
  101572: 246, // Bach-Pestwurz
  101573: 247, // Bergahorn
  101574: 248, // Bergdistel
  101575: 4031, // Buschwindröschen
  101576: 250, // Deutscher Skorpion
  101577: 83, // Erdkröte
  101578: 84, // Europäische Hornotter
  101579: 251, // Europäischer Dachs
  101580: 198, // Europäisches Alpenveilchen
  101582: 253, // Fieder-Zwenke
  101584: 254, // Frauenschuh
  101585: 255, // Fuchs-Knabenkraut
  101586: 256, // Gefleckte Taubnessel
  101587: 257, // Feuersalamander
  101588: 222, // Gemeine Fichte
  101589: 259, // Gewöhnliche Akelei
  101590: 260, // Gewöhnliche Felsenbirne
  101591: 261, // Gewöhnliche Goldrute
  101592: 262, // Gewöhnlicher Gilbweiderich
  101593: 263, // Gewöhnlicher Wurmfarn
  101596: 266, // Gophernatter
  101597: 267, // Grasfrosch
  101598: 268, // Große Brennnessel
  101599: 4013, // Grüne Buschviper
  101601: 270, // Hänge-Birke
  101602: 271, // Hasenglöckchen
  101604: 272, // Kartäusernelke
  101606: 101765, // Kletten-Distel
  101610: 275, // Krabbenspinnen
  101612: 276, // Krainer Lilie
  101615: 277, // Kreuzotter
  101616: 278, // Lippenblütler
  101618: 279, // Magerwiesen-Margerite
  101620: 280, // Nelkengewächse
  101621: 281, // Nickendes Perlgras
  101623: 282, // Orchideen
  101626: 284, // Rothirsch
  101628: 285, // Rundblättrige Glockenblume
  101631: 205, // Ruprechtskraut
  101633: 287, // Russischer Bär
  101634: 288, // Schaf-Schwingel
  101637: 289, // Seidenspinnen
  101638: 290, // Sonnenwend-Wolfsmilch
  101640: 291, // Spitzahorn
  101642: 292, // Stattliches Knabenkraut
  101644: 293, // Wald-Engelwurz
  101645: 294, // Wald-Erdbeere
  101647: 295, // Wasseramsel
  101648: 296, // Weiße Segge
  101650: 297, // Weiße Silberwurz
  101651: 298, // Weißtanne
  101653: 299, // Westliche Smaragdeidechse
  101655: 300, // Wiesen-Bärenklau
  101659: 302, // Wiesen-Kerbel
  101660: 303, // Wulfen-Primel
  101663: 304, // Zaunkönig
  101664: 305, // Zypressen-Wolfsmilch
  101979: 236, // Salweide
  101982: 224, // Grauerle
  101983: 229, // Zitterpappel
  101984: 228, // Eberesche
  101985: 233, // Manna-Esche
  101987: 221, // Gemeiner Wacholder
  101990: 238, // Schwarzkiefer
  101991: 237, // Echter Kreuzdorn
  101993: 232, // Weißdorn
  101994: 231, // Mehlbeere
  101999: 227, // Alpen-Pestwurz
  102003: 202, // Sichel-Wolfsmilch
  102013: 226, // Illyrischer Brand-Lattich
  102099: 193, // Vergissmeinnicht
  109699: 806, // Heidekraut
  110802: 1037, // Gefleckter Schmalbock
  110804: 1015, // Echte Schlüsselblume
  110805: 1023, // Gewöhnliche Berberitze
  110810: 1004, // Leberblümchen
  110811: 1005, // Mauereidechse
  110812: 1014, // Rote Samtmilbe
  110815: 1027, // Schwalbenwurz-Enzian
  110817: 999, // Quirlblättrige Zahnwurz
  110823: 1012, // Wiesen-Storchschnabel
  110828: 804, // Gams
  110831: 283, // Rotbuche
  111105: 1110, // Westliche Honigbiene
  112094: 197, // Dreischnittiger Baldrian
}
